import { Injectable } from '@angular/core';
import { WchService } from '../wch.service';
import { RenderingContext, CYCLE_HANDLING } from './../../../api';
import { Observable } from 'rxjs';

/* Copyright IBM Corp. 2017 */
const LOGGER = 'ContentResolverService';

@Injectable({ providedIn: 'root' })
export class ContentResolverService {

  // the API
  resolveRenderingContext: (aRenderingContext?: RenderingContext, aStrategy?: CYCLE_HANDLING)
    => Observable<RenderingContext | null | undefined>

  constructor(wchService: WchService) {
    // assign
    this.resolveRenderingContext = (aRenderingContext?: RenderingContext, aStrategy?: CYCLE_HANDLING) => wchService.resolveRenderingContext(aRenderingContext, aStrategy);
  }

}
